import { ShieldCheck, MessageCircle, ScrollText } from "lucide-react";
import { ORG } from "../data/siteData";

export const Hero = () => (
  <section id="hero" className="relative min-h-screen flex items-center overflow-hidden bg-[#0F0F11] pt-16" data-testid="hero-section">
    <span aria-hidden className="absolute -right-10 top-1/2 -translate-y-1/2 text-[22rem] leading-none font-heading text-white/[0.04] select-none pointer-events-none">柔道</span>
    <div className="max-w-6xl mx-auto px-4 sm:px-6 py-24 grid md:grid-cols-2 gap-12 items-center relative z-10">
      <div className="animate-fade-up">
        <div className="inline-flex items-center gap-2 border border-[#DC2626]/40 bg-[#DC2626]/10 text-[#EF4444] text-xs font-semibold uppercase tracking-widest px-4 py-1.5 rounded-full mb-8" data-testid="hero-badge-tcm">
          <ShieldCheck className="h-3.5 w-3.5" /> Transparência TCM-PA
        </div>
        <h1 className="font-heading text-4xl sm:text-5xl lg:text-6xl font-bold text-[#F8FAF8] tracking-tight leading-[1.05]" data-testid="hero-title">
          Formando cidadãos através da <span className="text-[#DC2626]">disciplina do judô</span>
        </h1>
        <p className="mt-6 text-base sm:text-lg text-zinc-400 leading-relaxed max-w-lg" data-testid="hero-subtitle">
          {ORG.razaoSocial} — entidade sem fins lucrativos que promove esporte, cultura e cidadania em Canaã dos Carajás - PA desde 2016.
        </p>
        <div className="mt-10 flex flex-wrap gap-4">
          <a href="#transparencia" data-testid="hero-cta-transparencia" className="inline-flex items-center gap-2 bg-[#DC2626] hover:bg-[#EF4444] text-white font-semibold px-6 py-3 rounded-full transition-colors duration-200">
            <ScrollText className="h-5 w-5" /> Portal da Transparência
          </a>
          <a href="#contato" data-testid="hero-cta-whatsapp" className="inline-flex items-center gap-2 border border-white/20 hover:border-[#DC2626] text-zinc-200 font-semibold px-6 py-3 rounded-full transition-colors duration-200">
            <MessageCircle className="h-5 w-5" /> Fale Conosco
          </a>
        </div>
        <div className="mt-12 grid grid-cols-3 gap-6 max-w-md" data-testid="hero-stats">
          <div><p className="font-heading text-3xl font-bold text-[#F8FAF8]">2016</p><p className="text-xs text-zinc-500 uppercase tracking-wider mt-1">Ano de fundação</p></div>
          <div><p className="font-heading text-3xl font-bold text-[#F8FAF8]">柔</p><p className="text-xs text-zinc-500 uppercase tracking-wider mt-1">Caminho suave</p></div>
          <div><p className="font-heading text-3xl font-bold text-[#F8FAF8]">Ativo</p><p className="text-xs text-zinc-500 uppercase tracking-wider mt-1">CNPJ regular</p></div>
        </div>
      </div>
      <div className="flex justify-center animate-fade-up" style={{ animationDelay: "0.15s" }}>
        <div className="relative">
          <div className="absolute inset-0 bg-[#DC2626] blur-3xl opacity-20 rounded-full" />
          <img src={`${process.env.PUBLIC_URL}/assets/logo-amacli.png`} alt="Associação Judô Itakira - AMACLI" className="relative w-64 sm:w-80 lg:w-96 object-contain drop-shadow-2xl" data-testid="hero-logo" />
        </div>
      </div>
    </div>
  </section>
);
